import React, { useState } from "react";
import Select, { StylesConfig } from "react-select";

export default function GlobalMultiSelect({
  className,
  items = [
    {
      value: "0",
      label: "option 1",
    },
  ],
  defaultOption = {
    value: "-1",
    name: "-- Select Multiple Options --",
  },
  name,
  onChange,
  value,
  id,
  placeholder = "",
  disabled = false,
  selectClassName,
  loading,
}) {
  const customStyles = {
    control: (provided) => ({
      ...provided,
      control: (provided, state) => ({
        ...provided,
        // borderColor: state.isFocused ? "#FECD08 !important" : "#F8F9FA",
        borderWidth: "2px", // Use hex color codes for focused and non-focused border colors
      }), // Add !important to override conflicting styles
    }),
    singleValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#FECD08" : "#FECD08", // Change this to your desired selected and non-selected background colors
    }),
    multiValue: (provided, state) => ({
      ...provided,
      backgroundColor: state.data.isSelected ? "#FECD08" : "#FECD08", // Change this to your desired selected and non-selected background colors
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };
  const [selectedOptions, setSelectedOptions] = useState([]);

  const handleOptionChange = (selectedOptions, e) => {
    var event = {
      target: {
        value: selectedOptions,
        name: e.name,
        id: id,
      },
    };

    console.log({ selectedOptions });
    setSelectedOptions(selectedOptions);
    onChange(event);
  };

  return (
    <div className={className}>
      <Select
        id={id}
        options={items}
        name={name}
        isLoading={loading}
        menuPortalTarget={document.body}
        menuPosition="fixed"
        placeholder={placeholder}
        isMulti
        className={`${selectClassName} border-1 border-[#808080] rounded-md w-full font-montserrat`}
        value={value ? value : selectedOptions}
        onChange={handleOptionChange}
        styles={customStyles}
        isDisabled={disabled}
      />
    </div>
  );
}
